module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1525-beeeb2e48b8f58c79d50ad4c493df4a0.png";